import React, { useEffect, useState } from 'react'
import { isArray, isPlainObject } from 'lodash-es'

const dealValue = (resolvedValue, defs, rowData, fields, hooks) => {
  // 处理 lookup
  const dealLookup = () => {
    const refValue = rowData[defs.lookup.refSlug]
    if (!refValue) {
      return null
    }

    if (!defs.lookup.lookupSlug) {
      return rowData[defs.refSlug]
    }
    // console.warn('[aa]', refValue, defs, defs.lookup.lookupSlug)

    if (isArray(refValue)) {
      return refValue.map((item) => item && item[defs.lookup.lookupSlug])
    }
    return refValue[defs.lookup.lookupSlug]
  }

  let finalValue = resolvedValue
  if (defs.lookup) {
    finalValue = dealLookup()
  }

  if (hooks && hooks.beforeTransform) {
    finalValue = hooks.beforeTransform(finalValue, defs, rowData, fields, hooks)
  }

  return finalValue
}

const Render = function ({
  value,
  defs,
  rowData,
  rowIndex,
  fields,
  hooks,
  rendersMap,
  Ditto,
}) {
  if (!defs) {
    return null
  }
  if (React.isValidElement(value)) {
    return value
  }
  // 开始执行 hooks
  const [finalValue, setFinalValue] = useState()

  useEffect(() => {
    // if (!value) return null

    if (value && value.then) {
      value.then((resolvedValue) => {
        setFinalValue(dealValue(resolvedValue, defs, rowData, fields, hooks))
      })
    } else {
      setFinalValue(dealValue(value, defs, rowData, fields, hooks))
    }

    return () => {
      if (value && value.then) {
        // 这里可以把 promise cancel 掉, 但是其实得包装下这个 promise
        // return Promise.cancel(value)
      }
    }
  }, [value, rowData])

  let field =
    isPlainObject(finalValue) && finalValue.render
      ? Ditto.transform(
          finalValue.render,
          finalValue.value,
          defs,
          rowData,
          fields,
          hooks
        )
      : Ditto.transform(defs.type, finalValue, defs, rowData, fields, hooks)
  // let field = Ditto.transform(
  //   defs.type,
  //   finalValue,
  //   defs,
  //   rowData,
  //   fields,
  //   hooks
  // )

  if (hooks && hooks.afterTransform) {
    field = hooks.afterTransform(field, { rowIndex })
  }

  const render =
    field && ((field.render && rendersMap[field.render]) || rendersMap.default)

  return <> {render && render(field)}</>
}

export default React.memo(Render)
